import { MetricConfig, TemplateContentType } from "@/types/template.types";

export const TEMPLATE_METRICS: Record<string, MetricConfig> = {
  spamScore: {
    label: "Spam Score",
    description:
      "Lower is better. Keep your spam score below 5 for best results.",
    thresholds: {
      min: 0,
      max: 100,
      warningThreshold: 40, // Above 40 shows yellow, above 40 shows red
    },
  },
  wordCount: {
    label: "Word Count",
    description: "Aim for 50-100 words for optimal engagement.",
    thresholds: {
      min: 50,
      max: 100,
      warningThreshold: 150, // Yellow between 50-150, red above 150
    },
  },
  spamWords: {
    label: "Spam Words",
    description: "Lower is better. Keep your spam words below 3.",
    thresholds: {
      min: 0,
      max: 3,
      warningThreshold: 5, // Yellow between 3-5, red above 5
    },
  },
  readabilityTime: {
    label: "Readability Time",
    description: "Ideal reading time is 11-60 seconds.",
    thresholds: {
      min: 11,
      max: 60,
      warningThreshold: 100, // Yellow between 20-25, red above 25
    },
    unit: "sec",
  },
  subjectLength: {
    label: "Subject Length",
    description: "Keep subject lines between 1-5 words for best open rates.",
    thresholds: {
      min: 1,
      max: 5,
      warningThreshold: 7, // Yellow between 5-7, red above 7
    },
  },
  numberOfLinks: {
    label: "Number of Links",
    description: "Include 1-2 links for optimal click-through rates.",
    thresholds: {
      min: 1,
      max: 2,
      warningThreshold: 3, // Yellow at 3, red above 3
    },
  },
  personalisation: {
    label: "Personalisation",
    description: "Use at least one personalisation for better engagement.",
    thresholds: {
      min: 1,
      max: 3,
      warningThreshold: 4, // Yellow at 4, red above 4
    },
  },
  questions: {
    label: "Questions",
    description: "Recommended between 0-2 questions.",
    thresholds: {
      min: 0,
      max: 2,
      warningThreshold: 3, // Yellow at 3, red above 3
    },
  },
  brokenLinks: {
    label: "Broken Links",
    description: "Try to avoid broken links.",
    thresholds: {
      min: 0,
      max: 0,
      warningThreshold: 1, // Yellow at 1, red above 1
    },
    showCondition: (contentType) => contentType === TemplateContentType.HTML,
  },
  upperCaseWords: {
    label: "Upper Case Words",
    description: "Lower is better. Keep your uppercase words below 5.",
    thresholds: {
      min: 0,
      max: 5,
      warningThreshold: 10, // Yellow at 1, red above 1
    },
  },
  dangerousHtml: {
    label: "Dangerous HTML",
    description: "Try to avoid dangerous HTML.",
    thresholds: {
      min: 0,
      max: 0,
      warningThreshold: 1, // Yellow at 1, red above 1
    },
    showCondition: (contentType) => contentType === TemplateContentType.HTML,
  },
  shortenedUrls: {
    label: "Shortened URLs",
    description: "Try to avoid shortened URLs.",
    thresholds: {
      min: 0,
      max: 2,
      warningThreshold: 3, // Yellow at 3, red above 3
    },
    showCondition: (contentType) => contentType === TemplateContentType.HTML,
  },
  imageCount: {
    label: "Image Count",
    description: "Recommended between 0-3 images.",
    thresholds: {
      min: 0,
      max: 10,
      warningThreshold: 20, // Yellow at 4, red above 4
    },
    showCondition: (contentType) => contentType === TemplateContentType.HTML,
  },
  emptyAltCount: {
    label: "Empty Image Alt Count",
    description: "Try to avoid empty image alt tags.",
    thresholds: {
      min: 0,
      max: 0,
      warningThreshold: 1, // Yellow at 1, red above 1
    },
    showCondition: (contentType) => contentType === TemplateContentType.HTML,
  },
  unsubscribeLink: {
    label: "Unsubscribe Link",
    description: "Try to have an unsubscribe link.",
    thresholds: {
      min: 0,
      max: 1,
      warningThreshold: 2, // Yellow at 0, red above 0
    },
  },
};
